import { render, staticRenderFns } from "./portfolio3.vue?vue&type=template&id=340bad7c&"
import script from "./portfolio3.vue?vue&type=script&lang=js&"
export * from "./portfolio3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports